<template>
    <ul class="list">
        <router-link tag="li" :to="{name:'DepartmentXq',params:{id:item.id}}" v-for="item in listInfo" :key="item.id">
            <div class="img">
                <img :src="item.image" alt="图片">
            </div>
            <p class="overhid">{{item.title}}</p>
        </router-link>
    </ul>
</template>
<script>
export default {
    props:['listInfo']
}
</script>
<style lang="scss" scoped>
    .list{
        width: 100%;
        font-size: 0;
        li{
            display: inline-block;
            width: 30%;
            margin-right: 5%;
            margin-bottom: 32px;
            transition: .3s ease-out;
            .img{
                width: 100%;
                overflow: hidden;
                img{
                    width: 100%;
                    transition: .3s ease-out;
                }
            }
            p{
                font-size: 24px;
                line-height: 64px;
                background-color: #F0F2F5;
                transition: .3s ease-out;
                width: 100%;
                box-sizing: border-box;
                padding: 0 12px;
            }
        }
        li:hover{
            box-shadow: 0 0 20px 0 #BABABA;
            .img{
                img{
                    transform: scale(1.1);
                }
            }
            p{
                background-color: #fff;
            }
        }
        li:nth-of-type(3n){
            margin-right: 0;
        }
    }
    @media screen and (max-width: 1200px){
        .list{
            li{
                width: 48%;
                margin-right: 4%;
                p{
                    font-size: 16px;
                    line-height: 46px;
                }
            }
            li:nth-of-type(3n){
                margin-right: 4%;
            }
            li:nth-of-type(2n){
                margin-right: 0;
            }
        }
    }
    @media screen and (max-width: 768px){
        .list{
            li{
                width: 100%;
                margin-right: 0;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/department/departList.vue